import axios from 'axios';

const api = axios.create({
  baseURL: 'https://api.portal.equiperemota.com.br/',
});

export default api;
